import { render, staticRenderFns } from "./Format0102.vue?vue&type=template&id=6165d82c&scoped=true"
import script from "./Format0102.vue?vue&type=script&lang=js"
export * from "./Format0102.vue?vue&type=script&lang=js"
import style0 from "./Format0102.vue?vue&type=style&index=0&id=6165d82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6165d82c",
  null
  
)

export default component.exports